import * as React from 'react'
import TopNavigation from '../../components/Navigation/TopNavigation';
import { Switch, Redirect, Route, RouteComponentProps } from 'react-router'
import ERoute from '../../ERoute'
import ProfileDetails from './Profile/ProfileDetails'
import ScrollToTopOnMount from '../../components/Effects/ScrollToTopOnMount';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import PageContent from '../../components/Page/PageContent';
import Notifications from './Profile/Notifications';
import Security from './Profile/Security';
import { AppState } from '../../store';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { BellIcon, ShieldIcon, UserIcon } from 'lucide-react';

type IProps = RouteComponentProps<{}>

const Profile = (props: IProps) => {
  const { location, history } = props
  const { t } = useTranslation()
  const currentUser = useSelector((state: AppState) => state.authentication.currentUser)

  const activeTab = location.pathname.includes(ERoute.PATH_ACCOUNT_PROFILE_SECURITY)
    ? 'security'
    : location.pathname.includes(ERoute.PATH_ACCOUNT_PROFILE_NOTIFICATIONS)
      ? 'notifications'
      : 'details'

  const onTabChange = (value: string) => {
    if (value === 'security') history.push(ERoute.PATH_ACCOUNT_PROFILE_SECURITY)
    else if (value === 'notifications') history.push(ERoute.PATH_ACCOUNT_PROFILE_NOTIFICATIONS)
    else history.push(ERoute.PATH_ACCOUNT_PROFILE_DETAILS)
  }

  return (
    <>
      <Helmet>
        <title>{t('Profile::{{__appName}} | Profile')}</title>
      </Helmet>
      <TopNavigation
        icon='user'
        title={t('Profile::Profile')}
      />

      <ScrollToTopOnMount />

      <PageContent>
        <div className='flex flex-col gap-6'>
          <div className="mb-4 flex items-center gap-6">
            <Avatar className='size-20'>
              <AvatarImage src={currentUser.avatar_url} alt={currentUser.name} />
              <AvatarFallback>{currentUser.name ? currentUser.name.slice(0, 2).toUpperCase() : currentUser.email.slice(0, 2).toUpperCase()}</AvatarFallback>
            </Avatar>
            <div className='flex flex-col'>
              <h1 className='text-2xl font-semibold!'>{currentUser.name || currentUser.email}</h1>
              <p className='text-muted-foreground text-sm'>{currentUser.email}</p>
            </div>
          </div>

          <Tabs value={activeTab} onValueChange={onTabChange}>
            <TabsList className="h-auto w-full justify-start gap-6 bg-transparent p-0">
              <TabsTrigger
                value='details'
                className="data-active:bg-primary data-active:text-primary-foreground"
              >
                <UserIcon />
                {t('Profile::Profile')}
              </TabsTrigger>
              <TabsTrigger
                value='security'
                className="data-active:bg-primary data-active:text-primary-foreground"
              >
                <ShieldIcon />
                {t('Profile::Security')}
              </TabsTrigger>
              <TabsTrigger
                value='notifications'
                className="data-active:bg-primary data-active:text-primary-foreground"
              >
                <BellIcon />
                {t('Profile::Notifications')}
              </TabsTrigger>
            </TabsList>
          </Tabs>

          <Switch location={location}>
            <Route path={ERoute.PATH_ACCOUNT_PROFILE_DETAILS} component={ProfileDetails} />
            <Route path={ERoute.PATH_ACCOUNT_PROFILE_SECURITY} component={Security} />
            <Route path={ERoute.PATH_ACCOUNT_PROFILE_NOTIFICATIONS} component={Notifications} />
            <Redirect from='/' to={ERoute.PATH_ACCOUNT_PROFILE_DETAILS} />
          </Switch>
        </div>
      </PageContent>
    </>
  )
}

export default Profile
